//src/app/features/payments/redirectionPages/paymentSuccessful/index.tsx
import { SuccessFancyIcon } from 'assets/icons';
import { CustomButton } from 'Components/Auth/CustomButton';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function PaymentSuccessful() {
  const navigate = useNavigate();

  return (
    <div className="  text-align-webkit-center mt-16 ">
      <SuccessFancyIcon className=" h-20 w-20" />
      <p className=" py-10 font-extrabold  text-medium ">
        {' '}
        Payment Done Successfully
      </p>
      <div className="w-1/3 inline-flex gap-4">
        <CustomButton
          text="Go Back to Dashboard"
          onClick={() => navigate(`/dashboard`)}
        />
      </div>
    </div>
  );
}
